import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionHitch"
const OptionHitchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M9.4 7.6V6.1c0-1.4-1.4-2.5-2.8-2.5S3.8 4.7 3.8 6.1v.7h1.3v-.7c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v1.5H3.8c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2V8.9c0-.7-.6-1.3-1.2-1.3zM18.2 4v.1h.1z" />
      <path d="M21.8 11.2c0-1.3-1.1-2.3-2.3-2.3s-2.3 1.1-2.3 2.3c0 1 .7 1.9 1.6 2.2 0 .9-.3 1.7-.8 2.5-1.6 2.7-5.1 3.6-7.8 2.1-1.2-.7-2-1.7-2.4-2.9l-5.1.1V17h4c.6 1 1.5 1.9 2.6 2.5 3.5 2 8 .8 10.1-2.7.6-1.1.9-2.3 1-3.4.8-.4 1.4-1.2 1.4-2.2z" />
    </svg>
  )
}
export default OptionHitchIcon
